import { render } from "./AutomaticBuilding.vue?vue&type=template&id=5cfcdecc&scoped=true"
import script from "./AutomaticBuilding.vue?vue&type=script&lang=js"
export * from "./AutomaticBuilding.vue?vue&type=script&lang=js"

import "./AutomaticBuilding.vue?vue&type=style&index=0&id=5cfcdecc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfcdecc"]])

export default __exports__